<template>
  <div class="donation-adoption-recipient">
    <h2>Recipient details</h2>

    <!-- Title -->
    <div class="wwf-field">
      <select
        name="title"
        v-model="donation.gift.title"
        v-validate="'required'"
        :class="{ error: errors.has('title'), empty: !donation.gift.title }"
        autocomplete="honorific-prefix"
      >
        <option value disabled selected>Select a title</option>
        <option value="Dr">Dr</option>
        <option value="Miss">Miss</option>
        <option value="Mr">Mr</option>
        <option value="Mrs">Mrs</option>
        <option value="Ms">Ms</option>
        <option value="Mx">Mx</option>
      </select>
      <label for="title">Select a title</label>
    </div>

    <!-- First Name -->
    <div class="wwf-field">
      <input
        name="firstName"
        type="text"
        v-model="donation.gift.firstname"
        v-validate="'required'"
        :class="{
          error: errors.has('firstName'),
          empty: !donation.gift.firstname,
        }"
        autocomplete="given-name"
      />
      <label for="firstName">First Name</label>
    </div>

    <!-- Last Name -->
    <div class="wwf-field">
      <input
        name="lastName"
        type="text"
        v-model="donation.gift.lastname"
        v-validate="'required'"
        :class="{
          error: errors.has('lastName'),
          empty: !donation.gift.lastname,
        }"
        autocomplete="family-name"
      />
      <label for="lastName">Last Name</label>
    </div>

    <h2>Recipient address</h2>

    <div class="cannot-deliver" v-if="cannotDeliver">
      We're sorry, gifts and toy products can only be delivered within
      Australia.
    </div>

    <AddressInput ref="AddressInput"></AddressInput>

    <!-- Next button -->
    <button type="button" class="plain" v-on:click="next()">
      <span>Next</span>
      <span><i class="fas fa-arrow-right"></i></span>
    </button>
  </div>
</template>

<script>
import AddressInput from "./AddressInput.vue";

import { mapState } from "vuex";

export default {
  name: "AdoptionRecipient",
  components: {
    AddressInput,
  },

  computed: {
    cannotDeliver() {
      return this.country != "Australia";
    },
    ...mapState({
      donation: (state) => state.donation.donation,
      country: (state) => state.donation.donation.addressInput.country,
    }),
  },

  methods: {
    async next() {
      try {
        // Validate form
        await Promise.all([
          this.validate(),
          this.$refs.AddressInput.validate(),
        ]);

        this.donation.gift = {
          ...this.donation.gift,
          ...this.$refs.AddressInput.getAddressDetails(),
        };

        // Commit the current step (Push to database)
        await this.commit();

        this.$store.dispatch("logFormRecipient");

        this.$emit("success");
      } catch (err) {
        console.error("Next - Error - ", err);
      }
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$validator
          .validateAll()
          .then((result) => {
            // Will return true if valid and false if not
            if (result) {
              resolve(result);
            } else {
              console.error("Recipient Details not valid - result", result);
              reject(result);
            }
          })
          .catch((err) => {
            console.error("Recipient Details Validation - Error - ", err);
            reject(err);
          });
      });
    },
    commit() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("saveDonation")
          .then((response) => {
            resolve();
          })
          .catch((error) => {
            console.error("saveDonation1 error", error);
            reject(error);
          });
      });
    },
  },
};
</script>

<style scoped>
.cannot-deliver {
  margin-bottom: 1rem;
  color: var(--errorColor);
}
</style>


// WEBPACK FOOTER //
// AdoptionRecipient.vue?34711cd5